export const PLATFORMS = [
  { key: "etsy", label: "Etsy", color: "#F1641E" },
  { key: "amazon", label: "Amazon", color: "#FF9900" },
  { key: "shopify", label: "Shopify", color: "#96BF48" },
  { key: "shopcom", label: "Shop.com", color: "#1B6FB9" },
];

export const platformLabel = (k) => PLATFORMS.find((p) => p.key === k)?.label || k;
